// @flow
import React from 'react';
import { Button } from 'sarsaparilla';
import type { aggregateResponse } from '../../model/aggregate';
import CellCoverageIcon from '../CellCoverageIcon';
import { calculateAverageCellSignal, describeCoverage } from '../../utils/cellCoverage';

type PropTypes = {
  aggregate: ?aggregateResponse,
  wrapper: 'div' | 'li',
};

export default class CellSummary extends React.PureComponent<PropTypes> {
  static defaultProps = {
    wrapper: 'div',
  };

  render() {
    const { aggregate, wrapper: Tag } = this.props;
    if (!aggregate || !aggregate.aggregate_cell_coverage_ratings) {
      return null;
    }
    const cellAverage = calculateAverageCellSignal(aggregate.aggregate_cell_coverage_ratings);
    const descriptArray = describeCoverage(cellAverage).split(' ');
    descriptArray.splice(1, 0, 'Mobile');
    return (
      <Tag className="ratReview-cell-summary-wrapper">
        <Button
          appearance="link"
          onClick={() =>
            document
              .getElementById('rating-review-inventory-review-section-heading')
              .scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
        >
          <CellCoverageIcon value={cellAverage} size="sm" />
          {descriptArray.join(' ')}
        </Button>
      </Tag>
    );
  }
}
